import { render, staticRenderFns } from "./CriteriaQuestionBlock.vue?vue&type=template&id=12ea6308"
import script from "./CriteriaQuestionBlock.vue?vue&type=script&lang=js"
export * from "./CriteriaQuestionBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports